var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0.17041C68.3 0.17041 88 19.8704 88 44.1704C63.7 44.1704 44 24.4704 44 0.17041ZM44 0.17041C19.7 0.17041 0 19.8704 0 44.1704C24.3 44.1704 44 24.4704 44 0.17041ZM0 44.1704C0 68.4704 19.7 88.1704 44 88.1704C44 63.8704 24.3 44.1704 0 44.1704ZM44 88.1704C68.3 88.1704 88 68.4704 88 44.1704C63.7 44.1704 44 63.8704 44 88.1704Z",
    fill: "#62246B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0 0.17041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon08);
export default __webpack_public_path__ + "static/media/icon_08.86b1d38f15a991051ef32f770f5e1fec.svg";
export { ForwardRef as ReactComponent };